import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import { COLORS, fontMixin, getColorByService } from "../../../../../../../../../styles";
import { ServiceName } from "../../../../../../../../../constants";

interface PLG_ContainerProps {
	$service: ServiceName;
}

export const PLG_Container = styled(motion.div)<PLG_ContainerProps>`
	display: flex;
	flex-direction: column;

	${({ $service }) => {
		const color = getColorByService($service);

		return css`
			${PLG_PercentPassed},
			${PLG_TimeValue}[data-variant="passed"] {
				color: ${color};
			}

			${PLG_ProgressLineFill} {
				background: ${color};
			}
		`;
	}}
`;

export const PLG_PercentPassed = styled(motion.div)`
	display: flex;
	justify-content: right;
	${fontMixin({ size: 36, weight: 300 })};
	margin-bottom: 10px;
	color: ${COLORS.Gold};
`;

export const PLG_ProgressLine = styled(motion.div)`
	position: relative;
	height: 6px;
	width: 100%;
	border-radius: 10px;
	background: ${COLORS.MidGray};
	margin-bottom: 14px;
`;

interface PLG_ProgressLineFillProps {
	$progress: number;
}

export const PLG_ProgressLineFill = styled(motion.div).attrs<PLG_ProgressLineFillProps>(({ $progress }) => ({
	initial: { width: 0 },
	animate: { width: `${$progress}%` },
	transition: {
		delay: 0.45,
		duration: 0.85,
		ease: [0.16, 1, 0.3, 1],
	},
}))<PLG_ProgressLineFillProps>`
	position: relative;
	height: 100%;
	border-radius: inherit;
	overflow: hidden;

	&::after {
		content: "";
		position: absolute;
		top: 0;
		bottom: 0;
		left: -40%;
		width: 40%;
		background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.55), transparent);
		animation: progressLineShine 1.1s ease 0.55s 1;
	}

	@keyframes progressLineShine {
		from {
			left: -40%;
		}
		to {
			left: 100%;
		}
	}
`;

export const PLG_TimeStats = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	align-items: center;
	gap: 40px;
`;

interface PLG_TimeStatProps {
	$align?: "left" | "right";
	$variant?: "passed" | "remain";
}

export const PLG_TimeStat = styled.div<PLG_TimeStatProps>`
	display: flex;
	align-items: center;
	justify-content: ${({ $align }) => ($align === "right" ? "flex-end" : "flex-start")};
	gap: 10px;
	${({ $variant }) =>
		$variant === "remain" &&
		css`
			${PLG_TimeValue} {
				color: ${COLORS.Red};
			}
		`}
`;

export const PLG_TimeLabel = styled.div`
	display: flex;
	width: 50px;
	${fontMixin({ size: 12 })};
	color: ${COLORS.Black};
	line-height: 15px;
`;

export const PLG_TimeValue = styled.div`
	${fontMixin({ size: 36, weight: 300 })};
	line-height: 44px;
	color: inherit;
`;
